import type { NextPage } from 'next';
import dynamic from 'next/dynamic';
import React from 'react';

import PageNextJs from 'nextjs/PageNextJs';

const BugBounty = dynamic(() => import('ui/pages/BugBounty'), { ssr: false });

const Page: NextPage = () => {
  return (
    <PageNextJs pathname="/bug-bounty">
      <BugBounty/>
    </PageNextJs>
  );
};

export default Page;
